import { FC, useMemo } from 'react'

import { Flex, HStack, Spacer, Spinner, Text } from '@chakra-ui/react'
import { getDiagramHeaders } from '@editor/services/InspectionSheet'
import { zeroPad } from '@editor/services/Util'
import { RootState } from '@editor/store/app'
import { useSelector } from 'react-redux'

import { PLUS_MINS_PADDING } from '../constants'

const TableHeader: FC<{
  isSaving?: boolean

  /**
   * All additional metrics' toggle state, including ones not belonging to this metric.
   */
  allAdditionalMetricsToggle?: boolean[]
}> = ({ isSaving, allAdditionalMetricsToggle = [] }) => {
  // Store
  const settings = useSelector((state: RootState) => state.inspectionSheet.settings)

  const { planeHeader } = useMemo(() => getDiagramHeaders(settings, false), [settings])

  return (
    <Flex className="inspection-sheet-table-header" fontSize="md">
      {/* Table header */}
      <HStack color="gray2.500" transition="width ease 0.3s">
        {isSaving && (
          <>
            <Spinner />
            <Text>保存中...</Text>
          </>
        )}
      </HStack>
      <Text
        w="var(--inspection-sheet-column-width)"
        className={['column', !settings.sheet_cols_visibility?.estimated_value ? 'hidden' : ''].join(' ')}
      >
        実測値
      </Text>
      <Text
        w="var(--inspection-sheet-column-width)"
        className={['column', !settings.sheet_cols_visibility?.designed_value ? 'hidden' : ''].join(' ')}
      >
        設計値
      </Text>
      <Text
        w="var(--inspection-sheet-column-width)"
        ml={`${PLUS_MINS_PADDING}px`}
        className={['column', !settings.sheet_cols_visibility?.tolerance ? 'hidden' : ''].join(' ')}
      >
        規格値
      </Text>
      <Text
        w="var(--inspection-sheet-column-width)"
        className={['column', !settings.sheet_cols_visibility?.designed_value ? 'hidden' : ''].join(' ')}
      >
        差
      </Text>

      {allAdditionalMetricsToggle.map((hidden, index) => (
        <Text
          key={`metrics-additional-column-${allAdditionalMetricsToggle.length}-${zeroPad(index, 2)}`}
          w="var(--inspection-sheet-column-width)"
          className={['column', hidden ? 'hidden' : ''].filter(Boolean).join(' ')}
        >
          &nbsp;
        </Text>
      ))}

      <Spacer flex={0} mr={5} />

      <Text w="var(--inspection-sheet-diagram-width)" className={['column', !planeHeader ? 'hidden' : ''].join(' ')}>
        {planeHeader}
      </Text>
    </Flex>
  )
}

export default TableHeader
